module.exports = __webpack_public_path__ + "img/报名采集模版示例一.843ea750.png";